import axios, { InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import envConfig from "../envConfig/envHelper";

type TokenRetrievalFunction = () => Promise<string | null>;

let getToken: TokenRetrievalFunction = async () => await null;

const { apiUrl } = envConfig.config;

const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
});

const apiClientPublic = axios.create({
  baseURL: apiUrl,
  withCredentials: false,
});

// The request interceptor to include the token in every request
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = await getToken();
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      } as AxiosRequestHeaders; // Cast the object to AxiosRequestHeaders type
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Function to set the token retrieval method
const setTokenRetrievalMethod = (
  tokenRetrievalMethod: TokenRetrievalFunction
): void => {
  getToken = tokenRetrievalMethod;
};

export { apiClient, setTokenRetrievalMethod, apiClientPublic };
